import { ColumnAlignment } from '../types';

const COLUMN_ALIGNMENTS: ColumnAlignment[] = ['left', 'center', 'right'];

// write-excel-file rejects unknown alignment values, so narrow the loosely-typed source field.
const resolveColumnAlignment = (value?: string): ColumnAlignment | undefined =>
  COLUMN_ALIGNMENTS.includes(value as ColumnAlignment)
    ? (value as ColumnAlignment)
    : undefined;

export default resolveColumnAlignment;
